import {Component, OnInit} from '@angular/core';
import {CurrentUserIsNotLoggedIn, UserService} from "../../services/user.service";
import {firstValueFrom} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {HubUser, Message, MessagesV1Service} from "../../apis/backend";
import * as SignalR from "@microsoft/signalr";

@Component({
    selector: 'session-menu',
    templateUrl: './session-menu.component.html',
    styleUrls: ['./session-menu.component.less']
})
export class SessionMenuComponent implements OnInit {

    public CurrentUserIsNotLoggedIn = CurrentUserIsNotLoggedIn;
    public currentUser: HubUser;
    public messages: Message[] = [];
    private _hubConnection: SignalR.HubConnection;

    constructor(
        private _httpClient: HttpClient,
        private _messagesService: MessagesV1Service,
        private _router: Router,
        private _userService: UserService) {
        _messagesService.getMessagesForCurrentUser().subscribe((messages) => {
            this.messages = messages;
        });
        
        _userService.CurrentUser.subscribe((user: HubUser) => {
            this.currentUser = user;
        });
    }

    ngOnInit() {
        this._hubConnection = new SignalR.HubConnectionBuilder()
            .withUrl('https://' + window.location.host + '/hubs/messages', {
                skipNegotiation: true,
                transport: SignalR.HttpTransportType.WebSockets
            })
            .build();

        this._hubConnection.start();

        this._hubConnection.on('ReceiveMessage', (message: Message) => this.handleMessage(message));
    }

    MessageClicked(messageID: number) {
        firstValueFrom(this._httpClient.post(`./api/v1/messages/${messageID}/acknowledge`, {}))
            .then(() => {
                let messageIndex = this.messages.findIndex((m: any) => m.MessageID == messageID);
                this.messages.splice(messageIndex, 1);
                this._router.navigate(['/messages'], {queryParams: {messageID}});
            });
    }
    
    public LastPosition: GeolocationPosition;
    
    GetLocation() {
        navigator.geolocation.getCurrentPosition(
            (position) => this.LastPosition = position,
            (error) => alert(error));
    }

    Logout() {
        this._userService.logout();
    }

    private handleMessage(message: Message) {
        if (this.currentUser &&
            message.IntendedForEmployee.EmployeeID == this.currentUser.UserID &&
            !this.messages.find(m => m.MessageID == message.MessageID))
        {
            this.messages.push(message);
        }
    }
}
